module.exports = __webpack_public_path__ + "static/mobilenav-previousscreen-dont-648a7ed39879d082e879510fd4eb4ed1.png";